import { all, call, put, takeLatest } from 'redux-saga/effects';
import { getBillableCountries, getCountries } from './country.actions';
import { hideLoader, showLoader } from '@topconagriculture/loader';
import { CountryLoaders } from '../config';
import { getBillableCountriesRestApi } from '../api/country/country.api';
import { getCountriesQuery } from '../api/country/country.queries';
export function* countriesFetch(gqlInstance) {
    if (!gqlInstance)
        return;
    yield put(showLoader(CountryLoaders.fetchCountries));
    try {
        const result = yield call(getCountriesQuery, gqlInstance);
        yield put(getCountries.done({
            params: {},
            result,
        }));
    }
    catch (err) {
        console.error('An error occurred retrieving countries.');
    }
    yield put(hideLoader(CountryLoaders.fetchCountries));
}
export function* billableCountriesFetch(subscriptionRestApiInstance) {
    if (!subscriptionRestApiInstance) {
        return;
    }
    yield put(showLoader(CountryLoaders.fetchCountries));
    try {
        const result = yield call(getBillableCountriesRestApi, subscriptionRestApiInstance);
        yield put(getBillableCountries.done({
            params: {},
            result,
        }));
    }
    catch (err) {
        console.error('An error occurred retrieving billable countries.');
    }
    yield put(hideLoader(CountryLoaders.fetchCountries));
}
export function watchCountrySaga(apiInstance) {
    return function* () {
        return yield all([
            yield takeLatest(getCountries.started, countriesFetch, apiInstance.gqlInstance),
            yield takeLatest(getBillableCountries.started, billableCountriesFetch, apiInstance.axiosSubscription),
        ]);
    };
}
//# sourceMappingURL=country.saga.js.map